// src\themes\mad\elements\Header\HeaderNavToggle.tsx
"use client";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useDrawerStore } from "@/stores/drawerStore";
import { HeaderNavSearch } from "./HeaderNavSearch";
import HeaderSelectLanguage from "./HeaderSelecetLanguage";
import { cn } from "@/core/lib/utils";

const GridIcon = ({ color = "#fff" }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.16675" y="1.16699" width="3" height="3" rx="1.5" fill={color} />
    <rect x="9.5" y="1.16699" width="3" height="3" rx="1.5" fill={color} />
    <rect x="17.8333" y="1.16699" width="3" height="3" rx="1.5" fill={color} />
    <rect x="1.16675" y="9.5" width="3" height="3" rx="1.5" fill={color} />
    <rect x="9.5" y="9.5" width="3" height="3" rx="1.5" fill={color} />
    <rect x="17.8333" y="9.5" width="3" height="3" rx="1.5" fill={color} />
    <rect x="1.16675" y="17.833" width="3" height="3" rx="1.5" fill={color} />
    <rect x="9.5" y="17.833" width="3" height="3" rx="1.5" fill={color} />
    <rect x="17.8333" y="17.833" width="3" height="3" rx="1.5" fill={color} />
  </svg>
);

export default function HeaderNavToggle() {
  const { primaryOpen, setPrimaryOpen } = useDrawerStore();
  const [scrolled, setScrolled] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 35);
    };

    // چک اولیه موقع لود صفحه (مثلاً اگر کاربر مستقیم به پایین صفحه لینک شده)
    handleScroll();

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setPrimaryOpen(!primaryOpen)}
        aria-label={primaryOpen ? "Close menu" : "Open menu"}
        className={`rounded-full backdrop-blur-md transition-all duration-300
        ${scrolled
            ? "rounded-full border border-primary-200"
            : "bg-primary-400/30 hover:bg-primary-500/50"
          }`}
      >
        <div className="flex">
          <GridIcon color={scrolled ? "#000" : "#fff"} />
        </div>
      </Button>
      <HeaderNavSearch scrolled={scrolled} />
      <HeaderSelectLanguage className={cn(scrolled
        ? "rounded-full border border-primary-200"
        : "bg-primary-400/30 hover:bg-primary-500/50")} />
    </>
  );
}
